import 'polyfill-nodelist-foreach'
import 'element-closest-polyfill'
import 'url-search-params-polyfill'
import 'promise/polyfill'
import 'whatwg-fetch'
import { windowLoaded, domReady } from './utilities/domready'
import { truncateText } from './utilities/helpers'
import { Pues } from './component/product/pues'
import { Reco } from './component/product/reco'
import { SearchRating } from './component/product/search-rating'
import { SearchFilter } from './component/product/filter'
import { StickyPUES } from './component/product/sticky'
import { Advisor } from './component/product/advisor';

new Pues().start();
new Pues().init();
new Reco().getLastseen();
new SearchRating().init();
new SearchFilter().init();
new SearchFilter().activeFilter();
new Advisor().campagne();

windowLoaded(() => {
    if(window.innerWidth >= 992) {
        // not being used as of https://team-schaefer-shop.atlassian.net/jira/software/c/projects/BF/boards/571?assignee=712020%3Af8d3964e-5d71-4cbc-90d3-d55e8117b1a7&selectedIssue=BF-95
        // let sticky = new StickyPUES();
        // sticky.init();
    } else {
        const elementsToTruncate: Array<HTMLElement> = Array.from(document.querySelectorAll('.expandable-content'));
        elementsToTruncate.forEach(element => (truncateText(element)));
    }
});
